import React, { useCallback, useEffect, useState } from 'react';
import VoxelCheckbox from '../../voxel/Forms/VoxelCheckbox';
import VoxelTooltipShort from '../../voxel/Tooltip/VoxelTooltipShort';
import { useComboTooltipHint } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/logic/useComboTooltipHint';
import {
  FormCombination,
  FormWordGroup,
} from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/models/ComboFormState';

export interface ComboCheckboxProps {
  cc: FormCombination;
  wordGroups: FormWordGroup[];
  handleSelectWordCombination: (combinationId: string, checked: boolean) => void;
  disabled: boolean;
}

export const ComboCheckbox: React.FC<ComboCheckboxProps> = React.memo(
  ({ cc, wordGroups, handleSelectWordCombination, disabled }) => {
    const [checked, setChecked] = useState(cc.selected);

    useEffect(() => setChecked(cc.selected), [cc.selected]);

    const handleToggle = useCallback(
      (value: boolean) => {
        handleSelectWordCombination(cc.id, value);
        setChecked(value);
      },
      [cc.id]
    );

    return (
      <VoxelTooltipShort message={useComboTooltipHint(cc, wordGroups).title} disabled={disabled}>
        <VoxelCheckbox
          checked={checked}
          label={cc.name}
          disabled={disabled}
          onChange={handleToggle}
        />
      </VoxelTooltipShort>
    );
  }
);
